import type Customer from "@acto/taskpane/core/domain/Customer";
import {
  type RevenuePeriod,
  useRankedClientsWithKpis,
} from "@acto/taskpane/core/data-access/customers/useRankedClientsWithKpis";

interface Result {
  customers: Customer[] | undefined;
  revenuePeriod: RevenuePeriod | null;
  isLoading: boolean;
  isLoadingMore: boolean;
  hasMore: boolean;
  loadMore: () => void;
}

const DEFAULT_PAGE_SIZE = 3;

// "Kunden im Fokus" for the Calendar page: only customers that have an observation
// (server-side `focusOnly` → ClientFilter.recommendedOnly), paginated (load 3, then more on scroll).
export function useFocusCustomerList({ pageSize = DEFAULT_PAGE_SIZE }: { pageSize?: number } = {}): Result {
  const result = useRankedClientsWithKpis({ limit: pageSize, focusOnly: true });

  const hasNoRowsToShow = result.data == null || result.data.length === 0;
  return {
    customers: result.data,
    revenuePeriod: result.revenuePeriod,
    isLoading: hasNoRowsToShow && (result.isPending || result.isFetching),
    isLoadingMore: result.isFetching && !hasNoRowsToShow,
    hasMore: result.hasNextPage,
    loadMore: result.fetchNextPage,
  };
}
